import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import type { DirectedCastPicturePending } from 'fym-shared/src/music24/directedVideoApi';
import { TypedMemo } from '../../common/types';
import { castMessages as messages } from '../messages/castMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the directed video; each part uses its own slice of it */
import styles from '../DirectedVideo.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** A photo that goes up now (design b3 "Uploading"). */
const UploadingCastCardComponent: React.FC<{ name: string }> = ({ name }) => {
  const intl = useIntl();
  return (
    <div className={styles.castCard} role="status">
      <div className={clsx(styles.picture, styles.pictureWorking)}>
        <div className={styles.shimmer} />
      </div>
      <div className={styles.castBody}>
        <div className={styles.labelText}>
          <span className={styles.spinner} aria-hidden />
          {intl.formatMessage(messages.uploading)}
        </div>
        <span className={styles.hint}>{name}</span>
      </div>
    </div>
  );
};

export const UploadingCastCard = TypedMemo(UploadingCastCardComponent);

/**
 * A picture that the image model makes now (design b3). It comes from `castPicturesPending` of the
 * video, so it stays after a reload. A failed picture is a `FailedCastCard`.
 */
const PendingCastCardComponent: React.FC<{ picture: DirectedCastPicturePending }> = ({ picture }) => {
  const intl = useIntl();
  return (
    <div className={styles.castCard} role="status" data-testid="cast-pending" data-status={picture.status}>
      <div className={clsx(styles.picture, styles.pictureWorking)}>
        <div className={styles.shimmer} />
      </div>
      <div className={styles.castBody}>
        <div className={styles.labelText}>
          {picture.label === '' ? intl.formatMessage(messages.unnamed) : picture.label}
        </div>
        <span className={styles.hint}>
          <span className={styles.spinner} aria-hidden />
          {intl.formatMessage(messages.makingPicture)}
        </span>
      </div>
    </div>
  );
};

export const PendingCastCard = TypedMemo(PendingCastCardComponent);
